module.exports = __webpack_public_path__ + "img/adv-mapIcon212.b84069d8.png";